import * as types from '../constants/ActionTypes';


export const getAllConversations = () => ({
    type: types.GET_ALL_CONVERSATIONS,
});

export const getAllConversationsSuccess = response => ({
    type: types.GET_ALL_CONVERSATIONS_SUCCESS,
    response,
});

export const switchConversation = conversationHash => ({
    type: types.SWITCH_CONVERSATION,
    conversationHash: conversationHash
});

export const switchConversationSuccess = response => ({
    type: types.SWITCH_CONVERSATION_SUCCESS,
    response: response,
});

export const conversationError = response => ({
    type: types.CONVERSATION_ERROR,
    response,
});

